import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoPageModule, PoTableModule, PoLoadingModule, PoAccordionModule, PoButtonModule, PoFieldModule, PoDividerModule, PoTabsModule, PoDynamicModule, PoModalModule, PoWidgetModule, PoInfoModule } from '@po-ui/ng-components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CotacaoRoutingModule } from './cotacao-routing.module';
import { CotacaoAbertoListComponent } from './cotacao-aberto-list/cotacao-aberto-list.component';
import { CotacaoAbertoEditComponent } from './cotacao-aberto-edit/cotacao-aberto-edit.component';
import { SharedModule } from '../shared/shared.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from '../authentication/interceptor/interceptor.service';




@NgModule({
  declarations: [CotacaoAbertoListComponent, CotacaoAbertoEditComponent],
  imports: [
    CommonModule,
    CotacaoRoutingModule,
    PoPageModule,
    PoTableModule,
    PoLoadingModule,
    PoAccordionModule,
    FormsModule,
    ReactiveFormsModule,
    PoButtonModule,
    PoFieldModule,
    PoDividerModule,
    PoTabsModule,
    PoDynamicModule,
    PoModalModule,
    PoWidgetModule,
    PoInfoModule,
    SharedModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true
    }
  ]
})
export class CotacaoModule { }
